export default __webpack_public_path__ + "57a0b474a065db407de06d1d159bfc7d.png";